var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.title,"placement":"top","open-delay":200}},[_c('span',{staticClass:"status-icon",class:_vm.iconClass},[(_vm.elIconName)?_c('i',{class:_vm.elIconName}):_c('span',{staticClass:"status-icon__text"},[_vm._v(_vm._s(_vm.iconText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }